module.exports = __webpack_public_path__ + "static/media/IoT.2873a503.png";